import { FeatureToggleClientService } from 'feature-toggle-client';
const openUserProfileModal = 'user-profile-on-first-login';
const contractAdminCanMigrateBots = 'contract-admin-can-migrate-bots';
const canMigrateBots = 'can-migrate-bots';
const aiAgentEnable = 'ai-agent-enable';
const pipelineEnable = 'pipeline-enable';
const useCarouselBanner = 'home-portal-use-carousel-banner';
const additionalPluginRecommendations = 'home-portal-additional-plugin-recommendations';
const bannerBlipCallsIsEnabled = 'banner-blip-calls-is-enabled';
const bannerBlipStoreFlagIsEnabled = 'banner-blip-store-flag-is-enabled';
const cardProductUpdatesIsEnabled = 'card-product-updates-is-enabled';
export class ListApplicationFeatures {
    static userProfileModalEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(openUserProfileModal);
    }
    static contractAdminCanMigrateBots() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(contractAdminCanMigrateBots);
    }
    static canMigrateBots() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(canMigrateBots);
    }
    static isAiAgentEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(aiAgentEnable);
    }
    static isPipelineEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(pipelineEnable, false);
    }
    static isUseCarouselBanner() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(useCarouselBanner, false);
    }
    static isAdditionalPluginRecommendationsEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(additionalPluginRecommendations, false);
    }
    static isBannerBlipCallsEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(bannerBlipCallsIsEnabled, false);
    }
    static isBannerBlipStoreFlagEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(bannerBlipStoreFlagIsEnabled, false);
    }
    static isCardProductUpdatesEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(cardProductUpdatesIsEnabled, false);
    }
}
